<!--
  Menu exclusivo para movil. La clase "contents md:hidden" saca este bloque del
  renderizado a partir del breakpoint de escritorio (768px, igual que header.component.scss)
  sin importar el valor de isOpen(), asi nunca puede aparecer en modo laptop.
-->
<div class="contents md:hidden">
  <!-- Overlay oscuro -->
  @if (isOpen()) {
    <button
      type="button"
      class="fixed inset-0 bg-gray-900/40 backdrop-blur-sm z-[100] transition-opacity duration-300"
      aria-label="Cerrar menú"
      (click)="close()"
    ></button>
  }

  <!-- Menú lateral -->
  <div
    class="fixed top-0 left-0 h-dvh min-h-screen max-h-dvh w-[85%] max-w-[320px] overflow-hidden bg-white z-[110] shadow-2xl transition-transform duration-300 ease-in-out transform flex flex-col rounded-r-[40px]"
    [class.-translate-x-full]="!isOpen()"
    [class.translate-x-0]="isOpen()"
>
  <!-- Header del menú -->
  <div class="flex items-center justify-between p-6 mb-4">
    <div class="w-32">
      <img src="assets/images/logo-gestion-espacios-horizontal.png" alt="Citylok" class="w-full h-auto" />
    </div>
    <button (click)="close()" class="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors">
      <fa-icon [icon]="faXmark" class="text-2xl"></fa-icon>
    </button>
  </div>

  <!-- Navegación -->
  <nav class="mt-2 flex-grow space-y-1 overflow-y-auto overscroll-contain px-3 pb-4">
    <a
      routerLink="/"
      routerLinkActive="bg-primary-light text-primary font-medium"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="close()"
      class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-secondary hover:text-secondary-light"
    >
      <fa-icon [icon]="faHome" class="text-base"></fa-icon>
      <span class="text-sm">Inicio</span>
    </a>

    <a
      routerLink="/espacios"
      routerLinkActive="bg-primary-light text-primary font-medium"
      (click)="close()"
      class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-secondary hover:text-secondary-light"
    >
      <fa-icon [icon]="faBuilding" class="text-base"></fa-icon>
      <span class="text-sm">Espacios</span>
    </a>

    <a
      routerLink="/ayuda"
      routerLinkActive="bg-primary-light text-primary font-medium"
      (click)="close()"
      class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-secondary hover:text-secondary-light"
    >
      <fa-icon [icon]="faCircleQuestion" class="text-base"></fa-icon>
      <span class="text-sm">Ayuda</span>
    </a>

    @if (authStore.isAuthenticated()) {
      <a
        routerLink="/mis-reservas"
        routerLinkActive="bg-primary-light text-primary font-medium"
        (click)="close()"
        class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-secondary hover:text-secondary-light"
      >
        <fa-icon [icon]="faCalendarDays" class="text-base"></fa-icon>
        <span class="text-sm">Mis reservas</span>
      </a>

      <a
        [routerLink]="userProfileRoute"
        routerLinkActive="bg-primary-light text-primary font-medium"
        (click)="close()"
        class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-secondary hover:text-secondary-light"
      >
        <fa-icon [icon]="faIdCard" class="text-base"></fa-icon>
        <span class="text-sm">Perfil</span>
      </a>
    }

    @if (authStore.isAdmin()) {
      <a
        routerLink="/admin"
        routerLinkActive="bg-primary-light text-primary font-medium"
        (click)="close()"
        class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all text-secondary hover:text-secondary-light"
      >
        <fa-icon [icon]="faGear" class="text-base"></fa-icon>
        <span class="text-sm">Administración</span>
      </a>
    }
  </nav>

  <!-- Pie del menú / Botón Acceder -->
  <div class="p-4 mt-auto border-t border-gray-100 shrink-0">
    @if (!authStore.isAuthenticated()) {
      <a
        routerLink="/login"
        (click)="close()"
        class="app-btn app-btn--primary app-btn--block h-[48px] text-base flex items-center justify-center gap-2"
      >
        <fa-icon [icon]="faRightToBracket"></fa-icon>
        Acceder
      </a>
    } @else {
      <button
        type="button"
        (click)="logout()"
        class="app-btn app-btn--secondary app-btn--block h-[48px] text-base flex items-center justify-center gap-2 w-full"
      >
        <fa-icon [icon]="faRightFromBracket"></fa-icon>
        Cerrar sesión
      </button>
    }
    </div>
  </div>
</div>
